import { apiFetch } from "./client.js";
import { encryptPassword } from "./crypto.js";
import { setTokens, setProfile, clearSession } from "./session.js";

// POST /v3/user/login — email + AES-encrypted password.
// Response: { data: { result: { authenticationToken, refreshToken } } }
export async function login(email, plaintextPassword) {
  const json = await apiFetch("/v3/user/login", {
    method: "POST",
    body: JSON.stringify({
      email: email.trim(),
      password: encryptPassword(plaintextPassword),
    }),
  });

  const result = json?.data?.result;
  if (!result?.authenticationToken) {
    throw new Error("Login succeeded but no token was returned.");
  }
  setTokens(result);
  return result;
}

// GET /v3/user/profileV2 — the bearer token is attached automatically.
// We persist the profile so the dashboard can read it on reload without
// re-fetching, and return it for the immediate post-login flow.
export async function fetchProfile() {
  const json = await apiFetch("/v3/user/profileV2", { method: "GET" });
  const profile = json?.data;
  if (profile) setProfile(profile);
  return profile;
}

// POST /v3/user/logout — tells the server to invalidate the session. The bearer
// token is attached automatically by apiFetch. We always clear the local
// session afterwards, even if the call fails (network error, already-expired
// token), so a failed request can never trap the user in a logged-in state.
export async function logout() {
  try {
    await apiFetch("/v3/user/logout", { method: "GET" });
  } catch {
    // ignore — the local session is cleared regardless below
  } finally {
    clearSession();
  }
}
